import gql from 'graphql-tag';

export const MEMBER_LOG_OUT = gql`
    query {
        memberLogout
    }
`;